import { render, staticRenderFns } from "./BenefitVehicle.vue?vue&type=template&id=ab457850"
import script from "./BenefitVehicle.vue?vue&type=script&lang=js"
export * from "./BenefitVehicle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports